import { useEffect } from "react"
import { useRequest } from "../hooks/useRequest"
import { usePaymentReturnListener } from "../hooks/usePaymentReturnListener"
import { useUnreadNotifications } from "../hooks/useUnreadNotifications"
import { useUnpaidOrderPoll } from "../hooks/useUnpaidOrderPoll"
import { ensureDeviceToken } from "../lib/deviceToken"
import { userStore } from "../store/userStore"

export const AppInitializer = () => {
    const { requestData } = useRequest()

    usePaymentReturnListener()
    useUnreadNotifications()
    useUnpaidOrderPoll()

    // PWA: регистрируем сервис-воркер сразу (кэширование + оболочка для установки).
    // Файл тот же, что использует FCM — повторная регистрация из webPush её переиспользует.
    useEffect(() => {
        if (!("serviceWorker" in navigator)) return
        navigator.serviceWorker.register("/firebase-messaging-sw.js").catch(() => {})
    }, [])

    useEffect(() => {
        ensureDeviceToken(requestData).catch(() => {
            /* токен подтянется повторно перед auth */
        })
        // requestData каждый рендер новый — не ставить в deps, иначе шторм /devicetoken
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // Важно для сайта: как только есть и user(Bearer) и deviceToken,
    // нужно зарегистрировать токен на бэке, чтобы он попал в таблицу пользователя.
    useEffect(() => {
        const unsub = userStore.subscribe(
            state => ({ userId: state.user?.id ?? null, deviceToken: state.deviceToken }),
            ({ userId, deviceToken }) => {
                if (!userId || !deviceToken) return
                requestData({
                    type: "POST",
                    path: "token",
                    sendData: { token: deviceToken },
                    disableError: true,
                }).catch(() => {})
            },
        )

        return () => unsub()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return null
}
